

import React, { useState } from 'react'
import d10 from './FullQuestionView.module.css';
import Image from '../ui/Image-utilities/Image'

import { IoArrowBack } from 'react-icons/io5'

import { doc, addDoc, deleteDoc, collection, serverTimestamp } from "firebase/firestore"
import { db, functions } from '../../firebase'

import { MdDelete } from 'react-icons/md'
import { FiMoreHorizontal } from 'react-icons/fi';
import { VscReport } from 'react-icons/vsc';
import { BsFillReplyAllFill } from 'react-icons/bs'

import ConfirmModal from '../ui/ConfirmModal';
import Ratings from '../ui/Ratings';
import DropUpMenu from '../ui/DropUpMenu';
import QuestionNoteForm from './QuestionNoteForm';

import AudioPlayer from '../ui/Audio-utilities/AudioPlayer'
import MultipleImages from '../ui/Image-utilities/MultipleImages';
import { urlify } from '../ui/text-utilities/TextProcessor'
import ReactLinkify from 'react-linkify';
import { AiOutlineClockCircle } from 'react-icons/ai';




//import QuestionNoteForm from './QuestionNoteForm';
import { httpsCallable } from 'firebase/functions';
import WhenNotAnswered from './questionsFullView/WhenNotAnswered';
function FullQuestionView({questionData,closeFullView}) {
console.log('question data from full',questionData);


      

  const [menuState, setMenuState] = useState('')
  const [optionDropDown, setOptionDropDown] = useState(false)
  async function deleteQuestion(qid) { await deleteDoc(doc(db, "questions", qid)); }
  //




  function breakLines(text) {
    return <ReactLinkify properties={{ target: '_blank', rel: "noreferrer noopener" }}>
      {text.split("\n").map((n, index) => <>{n}<br key={index} /></>)}
    </ReactLinkify>

  }



  const report = async (cause) => {
    setMenuState('thank you report');
    await addDoc(collection(db, 'reports'),
      {
        report_type: 'by student on teacher',
        report_cause: cause,
        reported_by_id: questionData.sender_id,
        reported_on_id: 'teacher',
        reportedAt: serverTimestamp(),
        question_id: questionData.question_id
      });


  };


  function menu() {
    switch (menuState) {

      case 'thank you report':
        return <div className={d10.reports}><h3> Thank you for reporting</h3></div>
      case 'report':
        return <div className={d10.reports}>
          <h3>Why are you reporting this question?</h3>
          <ul>

            <li onClick={() => report('Inappropriate')}>Inappropriate</li>
            <li onClick={() => report('Sexual Harrasment')}>Sexual Harrasment</li>
            <li onClick={() => report('Violent Words')}>Violent Words</li>
            <li onClick={() => report('Racist - religious attacks')}>Racist - religious attacks</li>
            <li onClick={() => report('Uneducational questions')}>Uneducational questions</li>
            <li onClick={() => report('Virus - Robot - Spam')}>Virus - Robot - Spam</li>
            <li onClick={() => report('iabolic signals - Words')}>Diabolic signals - Words</li>
          </ul>
        </div>
      default:
        return <ul>
          {questionData.question_status !== 'done' &&
      
      <ConfirmModal yes={() => {        
  // let func = httpsCallable(functions, 'deleteImages');
  deleteQuestion(questionData.question_id)
             }
            
            } message='Are you sure you want to delete the question?'>
              <li> <MdDelete /> Delete</li> </ConfirmModal>}
          <li onClick={() => setMenuState('report')}> <VscReport /> Report</li>
        </ul>
    }
  }

  

  return (
        <>

          <div className={d10.questionBar}>
            <button className={d10.button} onClick={closeFullView}><IoArrowBack size='30' /></button>
            <div className={d10.questionIn}>Question in: <div className={d10.subject}>{questionData.subject}</div></div>

            <div className={d10.dropDownContainer}>
              <button onClick={() => { setOptionDropDown(true); setMenuState('') }} className={d10.delete}><FiMoreHorizontal size='25' /></button>
              <DropUpMenu opened={optionDropDown} close={() => setOptionDropDown(false)}>
                {menu()}
              </DropUpMenu>
            </div>


          </div>
          {/* */}
          {<Ratings questionData={questionData} />}

          <section className={d10.question_container}>
            <h3>Question</h3>
            { questionData?.question_images.length > 0 &&
              questionData?.question_images[0]?.source !== '' &&
              <MultipleImages images={questionData.question_images} singleImageClass={d10.image} imageGroupName='question' />}


            {questionData.question && <p>{breakLines(questionData.question)}</p>}
            {questionData.question_audio && <AudioPlayer color={'#ffffff'} background={' rgba(255, 255, 255, 0.152)'} progressColor={'blue'} src={questionData.question_audio} />}


          </section>


          {( questionData.question_status !== 'pending' )
          
          ?


            <>
              <section className={d10.answer_container}>
                <h3>Answer</h3>
                {questionData.answer_images &&
                  questionData.answer_images.length > 0 &&
                  questionData.answer_images[0].source !== '' &&
                  <MultipleImages
                    images={questionData.answer_images}
                    singleImageClass={d10.image}
                    imageGroupName='answer' />}
                {questionData.answer && <p>{breakLines(questionData.answer)}</p>}
                {questionData.answer_audio && <AudioPlayer color={'grey'} background={'rgba(160, 160, 160, 0.19)'} progressColor={'#0C76FF'} src={questionData.answer_audio} />}
              </section>
              {(questionData.question_note || questionData.question_note_audio || questionData.question_note_img) &&
                <section className={d10.question_container}>
                  <h3>My Note <BsFillReplyAllFill /></h3>
                  {questionData.question_note_img &&
                    <Image src={questionData.question_note_img}
                      alt='no_img' className={d10.image} />}
                  <p>{questionData.question_note}</p>
                  {questionData.question_note_audio && <AudioPlayer color={''} background={'#rgba(12, 80, 255)'} progressColor={'#0C76FF'} src={questionData.question_note_audio} />}
                </section>
              }
              <section className={d10.reply_container}>
                <center>   <h3>Still didn't understand?</h3>
                  <h4>Leave a note:</h4></center>

                <QuestionNoteForm question_id={questionData.question_id} />
              </section>
            </>
            :
            <>
            <center className={d10.waitingForAnswerText}>Waiting to be answered <AiOutlineClockCircle /></center>
            <WhenNotAnswered questionData={questionData}/>
            </> 
          }
        </>
     
  )
}

export default FullQuestionView
